export enum TableViewMode {
  Detail = "Detail",
  Default = "Default",
  Summary = "Summary",
}
